var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "M14.722 1.668H5.278Q2.5 1.668 2.5 4.445v8.334q0 2.777 2.778 2.777h1.25c.437 0 .849.206 1.11.556l1.25 1.667a1.39 1.39 0 0 0 2.223 0l1.25-1.667c.262-.35.674-.556 1.11-.556h1.25q2.778 0 2.778-2.777V4.445q0-2.777-2.777-2.777",
  opacity: 0.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "m10.447 4.86.899 1.824a.46.46 0 0 0 .349.254l2.075.302c.38.055.533.525.257.794l-1.5 1.464a.47.47 0 0 0-.134.412l.343 2.005a.496.496 0 0 1-.72.525l-1.8-.948a.46.46 0 0 0-.43 0l-1.798.947a.498.498 0 0 1-.721-.526l.342-2.003a.47.47 0 0 0-.134-.412l-1.5-1.464a.466.466 0 0 1 .257-.794l2.075-.302a.46.46 0 0 0 .349-.254l.899-1.824c.183-.37.71-.37.892 0"
})));
export default SvgStarTag;